<template>
    <main-content with_go_back_bar>
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active"
                               data-toggle="tab"
                               href="#important_tickets"
                               role="tab"
                               id="important_tickets_link"
                               aria-selected="false"
                            >
                                {{ $t('label.important_tickets') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link"
                               data-toggle="tab"
                               href="#questions"
                               role="tab"
                               aria-selected="false"
                               id="questions_link"
                            >
                                {{ $t('label.questions') }}
                            </a>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
            </kt-panel-header>
        </kt-panel>
        <div class="tab-content">
            <div class="tab-pane active" id="important_tickets">
                <important-tickets></important-tickets>
            </div>
            <div class="tab-pane" id="questions">
                <questions></questions>
            </div>
        </div>
    </main-content>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import mainContent from '@/components/main-content'
import importantTickets from './components/important-tickets'
import questions from './components/questions'
export default {
    data() {
        return {
            active_pane: '#important_tickets',
            cat_hashid: this.$route.params.hashid
        }
    },
    components: {
        mainContent,
        importantTickets,
        questions
    },
    mounted() {
        $('a[data-toggle="tab"]').on('show.bs.tab', (e) => {
            this.active_pane = $(e.target).attr("href")
        })
	    this.activeTab()
    },
    methods: {
	    activeTab() {
		    let current_url = location.href;
		    let tab = current_url.split('#')[1]
		    if (tab) {
		    	$('#'+tab + '_link').click()
		    }
	    }
    },
    computed: {
        ...mapGetters('user', [
            'current_user'
        ])
    }
}
</script>

<style scoped>
.kt-portlet {
    margin-bottom: 1px !important;
}
</style>